/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail portal back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface Mail
 */
export interface Mail {
    /**
     * 
     * @type {string}
     * @memberof Mail
     */
    'folder': MailFolderEnum;
    /**
     * 
     * @type {number}
     * @memberof Mail
     */
    'uid': number;
    /**
     * 
     * @type {string}
     * @memberof Mail
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof Mail
     */
    'from'?: string;
    /**
     * 
     * @type {number}
     * @memberof Mail
     */
    'date'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Mail
     */
    'seen': boolean;
}

export const MailFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;

export type MailFolderEnum = typeof MailFolderEnum[keyof typeof MailFolderEnum];


